import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomePageComponent } from './modules/home-page/home-page.component';
import { AuthGuard } from './shared/auth.guard';
import { AboutComponent } from './modules/pages/about/about.component';
import { ContactUsComponent } from './modules/pages/contact-us/contact-us.component';
import { PrivacyPolicyComponent } from './modules/pages/privacy-policy/privacy-policy.component';
import { PropertiesComponent } from './modules/pages/properties/properties.component';
import { TooManyRequestPageComponent } from './modules/too-many-request-page/too-many-request-page.component';

const routes: Routes = [
  {
    path: '',
    component: HomePageComponent,
    pathMatch: 'full',
    data: {
      seo: {
        title: 'KB Imitation | Imitation Jewellery in Rajkot',
        description: 'Explore elegant imitation jewellery from KB Imitation in Rajkot, including earrings, jhumkas, and festive jewellery collections.',
      },
    },
  },
  {
    path: 'about',
    component: AboutComponent,
    data: {
      seo: {
        title: 'About KB Imitation | Imitation Jewellery in Rajkot',
        description: 'Learn about KB Imitation, your trusted Rajkot destination for stylish imitation jewellery and curated designs.',
      },
    },
  },
  {
    path: 'product',
    component: PropertiesComponent,
    data: {
      seo: {
        title: 'Imitation Jewellery Collection | KB Imitation',
        description: 'Browse earrings, jhumkas, and imitation jewellery from KB Imitation. Discover designs for everyday, festive, and ethnic wear.',
      },
    },
  },
  {
    path: 'contact-us',
    component: ContactUsComponent,
    data: {
      seo: {
        title: 'Contact KB Imitation | Rajkot Jewellery Store',
        description: 'Contact KB Imitation in Rajkot for imitation jewellery enquiries, product information, and support.',
      },
    },
  },
  {
    path: 'privacy-policy',
    component: PrivacyPolicyComponent,
    data: {
      seo: {
        title: 'Privacy Policy | KB Imitation',
        description: 'Read the KB Imitation privacy policy and learn how customer information is handled.',
      },
    },
  },
  {
    path: 'app',
    loadChildren: () => import('./modules/pages/pages.module').then((m) => m.PagesModule),
  },
  {
    path: 'too-many-requests',
    component: TooManyRequestPageComponent,
  },
  { path: '**', redirectTo: '/' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled',
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
